const value = {
    newPasswordTitle: 'Change Password',
    updatePasswordTitle: 'Update Password',
    newPasswordRequirementsBase:
      'Your new password must be strong and different from your current one. Make sure it includes:',
    updatePasswordRequirementsBase_part_1:
      'To continue using the system, you need to create a new password — this is a security requirement.',
    updatePasswordRequirementsBase_part_2:
      'It must be strong and different from your current one. Make sure the password includes:',
    passwordRequirements1: '— at least 8 characters;',
    passwordRequirements2: '— an uppercase and a lowercase letter;',
    passwordRequirements3: '— a digit;',
    passwordRequirements4: '— a special character (e.g. !, @, #).',
    oldPassword: 'Current Password',
    oldPasswordRequired: 'Please enter your current password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    passwordsDoNotMatch: 'The password and confirmation do not match',
    passwordLengthError: 'Minimum length is {{min}} characters',
    oldPasswordIncorrect: 'Current password is incorrect',
    passwordComplexityError:
      'Password must include an uppercase letter, lowercase letter, digit, and special character',
    newAndOldPasswordSame: 'New password must be different from the current one',
    directiveMissing: 'Password change is unavailable',
    save: 'Save',
  };

export default value;
